import React, { Component } from 'react';
import { HashRouter, Route, Link } from "react-router-dom";

import SearchBox from './components/SearchBox';
import SearchResultsList from './components/SearchResultsList';
import EntryView from './components/EntryView';

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchParams: {}
		};
	}

	render() {
		return (
			<HashRouter>
				<React.Fragment>

					<SearchBox />

					<br/><br/>

					<Route exact strict path="/fraedimenn/:searchString" render={(routeProps) => (
						<SearchResultsList onSearch={searchParams => this.setState({searchParams: searchParams})} {...routeProps} />
					)} />
					<Route exact strict path="/grein/:grein_id" render={(routeProps) => (
						<EntryView {...routeProps} />
					)} />

				</React.Fragment>
			</HashRouter>
		);
	}
}

export default App;
